import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import '../../css/market.css';
import LeadsMarket from './markets/leadsMarket';
import SpecType from './markets/searchBy/specType';
import MarketBlock from './markets/marketBlock';
import PurchasePage from './purchasePage';
import * as amplitude from "@amplitude/analytics-browser";


function CurrentPageHandler({ page, handleNavigation, setCurrentPage, setPathData, pathData}) {
	const agentInfo = useSelector((state) => state.agent.userData);
	useEffect(
		() => {
			try {
				amplitude.track(
					"Modal Viewed",
					{
						modal_name: "Market by Type Modal",
						trigger_source: "Funnel Market Dash",
						duration: null, // Figure out what "calculated" means
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"CurrentPageHandler: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
		},
		[],
	);
    let filteredData;
    if(page==='LevelUp Leads'){
        filteredData = pathData[0].types[0].filter(item => item.vendorName === page);
    }
    if(page==='Razor Ridge'){
        filteredData = pathData[0].types[0].filter(item => item.vendorName === page);
    }
    return (
        <>
            {page=='Leads' ? (
                <LeadsMarket setPathData={setPathData} handleNavigation={handleNavigation}/>
            ) : page === 'Market' ? (
                null,
                setCurrentPage(false)
            ) : page==='LevelUp Leads' || page==='Razor Ridge' ? (
                <MarketBlock data={[filteredData]} title={page} handleNavigation={handleNavigation}/>
            ) : page==='purchase' ? (
                <PurchasePage data={pathData}/>
            ) : (
                <SpecType data={pathData} title={page} handleNavigation={handleNavigation}/>
            )}
        </>
    );
}

export default CurrentPageHandler;
